import { FCX } from "@datassential/platform-ui-lib";
import { useConsumerGroupsContext } from "@pages/Profile/components/ConsumerGroups/ConsumerGroups";
import { useHotels } from "@core/CommonDataContext";
import {
    ConsumerGroupsTableItem,
    useConsumerGroupsTableMetrics
} from "./ConsumerGroupsTableConfig";
import { useMemo } from "react";
import Common from "@pages/Profile/components/ConsumerGroups/Common";

const Hotels: FCX = (props) => {
    const getMetricsData = useConsumerGroupsTableMetrics();
    const { data } = useConsumerGroupsContext();

    const options = useHotels();

    const hotelsData = useMemo(
        (): ConsumerGroupsTableItem[] => {
            return (data.hotels ?? []).map((item) => {
                const itemData = options.find((i) => i.id === item.id);

                return {
                    id: item.id,
                    name: itemData?.name ?? '',
                    baseSize: item.base ?? 0,
                    metrics: getMetricsData(item.metrics ?? []),
                };
            });
        },
        [options, data.hotels, getMetricsData]
    );

    return (
        <Common {...props} data={hotelsData} isVirtualized/>
    );
}

export default Hotels;